import { useFeatureFlags } from '../../../../services/featureFlags/hooks/useFeatureFlags';
import { DateRangeKey } from '../../../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';

export const useGrapeReportDateRangeKeys = (): DateRangeKey[] => {
  const { Diagnostics } = useFeatureFlags();

  // Extended date range options for internal users
  return Diagnostics
    ? ['week', '30days', '90days', '180days', '365days']
    : ['week', '30days'];
};
